import { BaseApi } from '@shared/config';
import type { GetEducationLevelsResponse } from './types';

class EducationLevelApi extends BaseApi {
  getEducationLevels = (): Promise<GetEducationLevelsResponse> => {
    return this.instance.get('/education-levels');
  };
}

export const educationLevelApi = new EducationLevelApi();
